import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthenticationService } from './services/authentication.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { trigger, transition, group, query, style, animate } from '@angular/animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.maincomponent.html',
  styleUrls: ['./app.maincomponent.css'],
  animations: [
    trigger('routeAnimation', [
      transition('1 => 2', [
        style({ height: '!' }),
        query(':enter', style({ transform: 'translateX(100%)' })),
        query(':enter, :leave', style({ position: 'absolute', top: 0, left: 0, right: 0 })),
        // animate the leave page away
        group([
          query(':leave', [
            animate('0.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(-100%)' })),
          ]),
          // and now reveal the enter
          query(':enter', animate('0.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(0)' }))),
        ]),
      ]),
      transition('3 => 2, 2 => 1', [
        style({ height: '!' }),
        query(':enter', style({ transform: 'translateX(-100%)' })),
        query(':enter, :leave', style({ position: 'absolute', top: 0, left: 0, right: 0 })),
        // animate the leave page away
        group([
          query(':leave', [
            animate('0.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(100%)' })),
          ]),
          // and now reveal the enter
          query(':enter', animate('0.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(0)' }))),
        ]),
      ]),
    ])
  ]
})
export class AppMainComponent {
  title = 'app';
  isLoggedIn: boolean = false;
  regionDisplayName: string;
  employeeDisplayName: string;

  //isLoggedIn = localStorage.getItem("username") !== null;
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private meta: Meta,
    activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.meta.addTag({ 'http-Equiv': 'X-UA-Compatible', content: "IE=edge" });

    this.authenticationService.loggedIn.subscribe(response => this.isLoggedIn = response);
    this.authenticationService.employeeDisplayName.subscribe(response => this.employeeDisplayName = response);
  }
  logOut() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  getDepth(outlet) {
    return outlet.activatedRouteData['depth'];
  }
}
